
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import notifications from "@/lib/notifications";
import {
  AgentResource,
  AgentDeliveryForResource,
} from "../../../models/api/system/agents";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import permissions from "@/security/permissions";
import router from "@/router";

const systemModule = getModule(SystemModule);

@Component({
  components: {}
})
export default class ManageDeliveryFors extends Vue {
  @Prop()
  public agent:AgentResource;
    
  @Prop()
  public agentDeliveryFors: Array<AgentDeliveryForResource>;

  loading: boolean = false;
  loadingPage: boolean = false;
  
  agentDeliveryFor: AgentDeliveryForResource = {
    id: null,
    agentId: null,
    name: null,
    color: null,
    isActive: true
  };



  isDeliveryForModalVisible: boolean = false;
  isDeleteDeliveryForModalVisible: boolean = false;


  formatColor(color: string) {
    if(!color)
      return color;
    
    const thisRegex = /(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})/g
    if(color.match(thisRegex)) {
        if(color.substring(0,1) != "#") {
          return `#${color.toUpperCase()}`;
        }
        else {
          return color.toUpperCase();
        }
    }
    return color[0].toUpperCase() + color.substring(1).trim();
  }


   addAgentDeliveryFors() {
    this.agentDeliveryFor = {
      id: null,
      agentId: this.agent.id,
      name: null,
      color: null,
      isActive: true
    };
    this.isDeliveryForModalVisible = true;
  }

  editAgentDeliveryFors(id: number) {
    let clone = this.agentDeliveryFors.find(x => x.id === id);
    clone = { ...clone };

    this.agentDeliveryFor = clone;
    this.isDeliveryForModalVisible = true;
  }

  showAgentDeliveryForsDeleteConfirmation(id: number) {
    let clone = this.agentDeliveryFors.find(x => x.id === id);
    clone = { ...clone };

    this.agentDeliveryFor = clone;
    this.isDeleteDeliveryForModalVisible = true;
  }

  async saveDeliveryFor() {
    this.agentDeliveryFor.color = this.formatColor(this.agentDeliveryFor.color);
    try {
      if (this.agentDeliveryFor.id === null) {
        this.agentDeliveryFor.agentId = this.agent.id;
        await systemModule.postAgentDeliveryFor(this.agentDeliveryFor);
      } else {
        await systemModule.putAgentDeliveryFor(this.agentDeliveryFor);
      }
      notifications.success("Success", "Delivery for saved.");
    } catch (error) {
      notifications.error("Save Failed", "Unable to save delivery for.", error);
    }

    this.$emit("updated");
  }

  async deleteDeliveryFor() {
    try {
      await systemModule.deleteAgentDeliveryFor(this.agentDeliveryFor.id);
      notifications.success("Success", `Delivery for deleted.`);
    } catch (error) {
      notifications.error("Delete Failed", "Unable to delete delivery for.", error);
    }

    this.$emit("updated");
  }


  done() {
    router.push(`/admin/agents`);
  }
}
